import { flattenChildren } from '../render/render-entry';
export function normalizeChildrenToNodes(children) {
    if (children === null || children === undefined)
        return [];
    if (Array.isArray(children)) {
        return flattenChildren(children);
    }
    return flattenChildren([children]);
}
/**
 * If the children are purely static text nodes (no props/children),
 * return the concatenated string. Otherwise return undefined.
 */
export function extractStaticText(children) {
    if (children.length === 0)
        return undefined;
    let out = '';
    for (const child of children) {
        const text = child.text;
        if (child.type !== 'Text' || typeof text !== 'string')
            return undefined;
        if (child.children.length > 0)
            return undefined;
        if (Object.keys(child.props ?? {}).length > 0)
            return undefined;
        out += text;
    }
    return out;
}
//# sourceMappingURL=children.js.map